import React from 'react';
import classNames from 'classnames';
import { tupleNum } from 'antd/lib/_util/type';
import { ConfigContext } from '../config-provider';
import { Space as AntdSpace } from 'antd';
const Space_ELE_LIST = tupleNum(1, 2, 3, 4, 5, 6, 7, 8);
const Space = (props) => {
    const { level, prefixCls: customizePrefixCls, className, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const mergedClassName = classNames({
        [`${prefixCls}-level-${level}`]: level
    }, className);
    return React.createElement(AntdSpace, { prefixCls: prefixCls, className: mergedClassName, ...otherProps });
};
// const ConfiguredSpace = withConfigProvider(Space);
// export { ConfiguredSpace as Space };
// export default ConfiguredSpace;
export default Space;
